package com.bikompanion.ui.strings

/** Lyricist has no plural support, so each language picks its form here, by CLDR's rules. */
internal fun singularOrPlural(
    count: Int,
    one: String,
    other: String,
) = if (count == 1) one else other

internal fun russianPlural(
    count: Int,
    one: String,
    few: String,
    many: String,
): String {
    val lastTwo = count % 100
    val last = count % 10
    return when {
        last == 1 && lastTwo != 11 -> one
        last in 2..4 && lastTwo !in 12..14 -> few
        else -> many
    }
}

internal fun arabicPlural(
    count: Int,
    zero: String,
    one: String,
    two: String,
    few: String,
    many: String,
    other: String,
): String {
    val lastTwo = count % 100
    return when {
        count == 0 -> zero
        count == 1 -> one
        count == 2 -> two
        lastTwo in 3..10 -> few
        lastTwo in 11..99 -> many
        else -> other
    }
}
